import { render, staticRenderFns } from "./LabelsFilter.vue?vue&type=template&id=2541a9f0"
import script from "./LabelsFilter.vue?vue&type=script&lang=js"
export * from "./LabelsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports